import { ElMessage } from 'element-plus'

import { CircleCloseFilled, SuccessFilled } from '@element-plus/icons-vue'

type IType = 'success' | 'error'

export default () => {
  const showMessage = (type: IType, message: string, duration = 4000) => {
    const typeMappings: Record<
      IType,
      { iconComponent: any; customClass: string }
    > = {
      success: {
        iconComponent: SuccessFilled,
        customClass: 'success-msg'
      },
      error: {
        iconComponent: CircleCloseFilled,
        customClass: 'error-msg'
      }
    }

    const { iconComponent, customClass } = typeMappings[type]

    ElMessage({
      type: type,
      message: message,
      icon: iconComponent,
      customClass: customClass,
      duration
    })
  }

  const getErrorMessage = (error: any) => {
    if (error.response) {
      const errorMessage = error.response.data.message
      let message = error.response.data.message
      if (Array.isArray(errorMessage)) {
        message = error.response.data.message[0]
      }
      return message
    }
    // Fallback for errors without response object
    return error.message || 'An error occurred'
  }

  return {
    showMessage,
    getErrorMessage
  }
}
